export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";

export const CREATEPRODUCT = "CREATEPRODUCT";
export const DELETEPRODUCT = "DELETEPRODUCT";
export const UPDATEPRODUCT = "UPDATEPRODUCT";
export const FETCH_ALLPRODUCTS = "FETCH_ALLPRODUCTS";
export const FETCHPRODUCT = "FETCHPRODUCT";
export const UPDATEPRODUCTGALLERY = "UPDATEPRODUCTGALLERY";
export const DELETEIMAGE = "DELETEIMAGE";

export const CREATEORDER = "CREATEORDER";
export const DELETEORDER = "DELETEORDER";
export const UPDATEORDER = "UPDATEORDER";
export const FETCHORDERS = "FETCHORDERS";
export const FETCHORDER = "FETCHORDER";
export const FETCHTOTALINCOME = "FETCHTOTALINCOME";

export const CREATECATEGORY = "CREATECATEGORY";
export const DELETECATEGORY = "DELETECATEGORY";
export const UPDATECATEGORY = "UPDATECATEGORY";
export const FETCHCATEGORYS = "FETCHCATEGORYS";
export const FETCHCATEGORY = "FETCHCATEGORY";

export const CREATEUSER = "CREATEUSER";
export const DELETEUSER = "DELETEUSER";
export const UPDATEUSER = "UPDATEUSER";
export const FETCHUSERS = "FETCHUSERS";
export const FETCHUSER = "FETCHUSER";

export const FETCHSTORE = "FETCHSTORE";
export const CREATESTORE = "CREATESTORE";
export const UPDATESTORE = "UPDATESTORE";
export const FETCH_ALL_STORES = "FETCH_ALL_STORES";

export const CREATESHIIPING = "CREATESHIIPING";
export const FETCHSHIIPING = "FETCHSHIIPING";
export const FETCHALLSHIPPINGS = "FETCHALLSHIPPINGS";
export const UPDATESHIIPING = "UPDATESHIIPING";
export const DELETESHIPPING = "DELETESHIPPING";

export const CREATESTATICINFO = "CREATESTATICINFO";
export const UPDATESTATICINFO = "UPDATESTATICINFO";
